import authHeader from "../../../../authentication/authservices/auth-header";
import apiClient from "../../../../http-common";

export const saveICUDischargeCheckList = (postObj) => {
  return apiClient.post(
    `/clinicalCareChart/saveICUDischargeChecklist`,
    postObj,
    {
      headers: authHeader(),
    },
  );
};

export const getICUDischargeCheckList = () => {
  return apiClient.get(`/nursingMaster/getIcuDischargeChecklist`, {
    headers: authHeader(),
  });
};
